// stores/userStore.js
import { defineStore } from "pinia";

import { fetchUserData, fetchSchedule, fetchAppointments, fetchSystemOptions, changeSecurityGroup, setUserCredentials, fetchPatientPanel } from "@/api/userApi";

import { fetchMyMeasures } from "@/api/workListsApi.ts";

import axios from "axios";

import { createPinia } from "pinia";
import { useDashboardsStore } from "@/stores/dashboardsStore";
import { usePatientStore } from "@/stores/patientStore";
import { useStoreWorkList } from "@/stores/workListsStore";

// * STOREs
import { useUsersPatientsStore } from "@/stores/usersPatientStore";

export const useStoreUser = defineStore("userStore", {
  state: () => {
    return {
      authorizations: {},
      accessToken: "",
      isAuthenticated: false,

      role: "",
      roles: [],

masterRoles: [
  "(ADMIN)|Global_Admin",
  "(ADMIN)|Module_Admin",
  "(ADMIN)|Portal_Admin",
  "(CMGT)|Clinician",
  "(CMGT)|Coder",
  "(CMGT)|Module_Admin",
  "(CODE)|Global_Admin",
  "(CODE)|Portal_Admin",
  "(DATA)|Global_Admin",
  "(DATA)|Portal_Admin",
  "(EMRS)|AllScripts_User",
  "(EMRS)|AllScripts_Viewer",
  "(EMRS)|Epic_User",
  "(EMRS)|Epic_Viewer",
  "(HCCW)|Clinician",
  "(HCCW)|ClinicianProxy",
  "(HCCW)|Coder",
  "(HCCW)|Global_Admin",
  "(HCCW)|Module_Admin",
  "(HCCW)|Nurse",
  "(HCCW)|Office_Staff",
  "(HCCW)|Portal_Admin",
  "(INFO)|Viewer",
  "(PATP)|Clinician",
  "(PATP)|Coder",
  "(PATP)|Global_Admin",
  "(PATP)|Module_Admin",
  "(PATP)|Nurse",
  "(PATP)|Office_Staff",
  "(PATP)|Patient",
  "(PATP)|Portal_Admin",
],
      systemOptionsFormArray: [],

      currentSecurityGroup: null,
      ihaSecurityMaster: "abbe17a7-05ad-479b-8e8c-ec80a880cd13",
      ruralFamilyMedicineGroup: "b6a74025-2ef2-476d-95f0-fceb32b38449",
      hasFullPatientChart: true,
      userCanEditAlertMessage: true,
      securityGroups: null,
      reloadDashboard: 0,
      users: [],
      membership: [],
      businesses: [],
      userLists: [],

      _user: {
        name: "",
        userName: "",
        userPassword: "",
        defaultBusinessId: "",
        fullName: "",
        initialPatientIDList: [],
        selectedPatients: [],
        devExTheme: "generic.light.white",
      },
      searchTermStore: "stahl, wilma",
      patientPanels: [],

      devExTheme: "generic.light.white", // "generic-light",
      lsbTheme: "light-white-theme", //"white-theme",
      bModalTheme: "generic-light-white-modal", // "generic-light-modal", // <-- Set default value here
    };
  },
  // could also be defined as
  actions: {
    async fetchUserData() {
      // console.clear();
      // console.log(" USER STORE  >  fetchUserData");
      const result = await fetchUserData();
      // console.log("Result from fetchUserData: ", result);

      if (result.ok) {
        this.updateUser(result.payload);
      }
    },
    // mutations can now become actions, instead of `state` as first argument use `this`
    updateUser(payload) {
      // console.log(" STR updateUser");

      // console.log(payload);

      this._user = payload.user;

      //! & NEW 03/27/2026 TOO BIND0
      // this._user.officeId = 1;

      this._user.userName = payload.userSessionData.userName;
      this._user.userPassword = payload.userSessionData.userPassword;

      const incomingDevExTheme = payload?.userSessionData?.devExTheme;
      this._user.devExTheme = incomingDevExTheme ?? this._user.devExTheme ?? "generic.light.white";
      this.devExTheme = this._user.devExTheme;

      this._user.selectedPatients = payload.selectedPatients;

      this._user.initialPatientIDList = [];

      const incomingPatientIdList = payload?.userSessionData?.patientIdList;

      if (incomingPatientIdList) {
        try {
          const parsedPatientIds = JSON.parse(incomingPatientIdList);
          this._user.initialPatientIDList = Array.isArray(parsedPatientIds) ? parsedPatientIds : [];
        } catch (error) {
          console.warn("Invalid patientIdList payload; defaulting to empty array.", error);
          this._user.initialPatientIDList = [];
        }
      }

      // console.log(this.initialPatientIDList)
      // console.log(this._user.initialPatientIDList);

      // * send to userspatiientStore
      // console.log("  SEND  initialPatientIDList  2 UsersPatientStore            HOOK  to usersPatStore   patientIDStartList");
      const usersPatStore = useUsersPatientsStore();

      usersPatStore.patientIDStartList = [];
      usersPatStore.patientIDStartList = [...this._user.initialPatientIDList]; // Create a shallow copy
      // usersPatStore.scheduledPatients = [];

      // console.log("usersPatStore.patientIDStartList          SET ");
      // console.dir(usersPatStore.patientIDStartList);

      // console.log(" GET PATIENT MASTER LIST   ON   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ");

      // usersPatStore
      //   .getPatientMasterList()
      //   .then(() => {
      //     // console.log("***************************                    Patient master list loaded successfully");
      //   })
      //   .catch((error) => {
      //     console.error("Error loading patient master list:", error);
      //   });

      // console.log("usersPatStore.masterPatientList");
      // console.log(usersPatStore.masterPatientList);

      // console.log(" GET Todays Patient List   OFF ");
      // Call the action and handle it properly
      // usersPatStore.getTodaysPatientList().then(() => {
      //     console.log("Today's patient list loaded successfully");
      //   })
      //   .catch((error) => {
      //     console.error("Error loading today's patient list:", error);
      //   });
      // console.log("usersPatStore.todaysPatientList");
      // console.log(usersPatStore.todaysPatientList);

      //from the master list find the id from initialPatientIDList where id = personID

      // console.log(" GET Patient List FROM SCHEDULE   ON ");
      // usersPatStore
      //   .getPatientListFromSchedule()
      //   .then(() => {
      //     console.log("Patient list from schedule loaded successfully");
      //   })
      //   .catch((error) => {
      //     console.error("Error loading patient list from schedule:", error);
      //   });
      // console.log("usersPatStore.patientListFromSchedule");
      // console.log(usersPatStore.patientListFromSchedule);

      // & update PROPS
      this.authorizations = payload.authorizations;

      this.role = payload.role;
      // & 4 TESTIING
      // this.role = 'Clinician'

      this.roles = payload.roles;

      this.securityGroups = payload.securityGroups;
      // ? DIG THIS >> setCurrentSecurityGroup(state)
      let currentGroup = this.securityGroups?.find((group) => group.isDefault);
      // in case there is no default, then just choose the first one
      if (!currentGroup && this.securityGroups) {
        this.currentSecurityGroup = this.securityGroups[0].id;
      } else if (currentGroup) {
        this.currentSecurityGroup = currentGroup.id;
      }

      this.users = payload.users;

      this.membership = payload.membership;
      this.businesses = payload.businesses;
      this.userLists = payload.userLists;
    },
    storeUserData(userData) {
      // console.log("  USER STORE  >  storeUserData");
      // console.log(userData);

      this.authorizations = userData.authorizations;
      this.role = userData.role;
      this.securityGroups = userData.securityGroups;

      //  setCurrentSecurityGroup(state)
      // * pull the code upstairs
      let currentGroup = this.securityGroups?.find((group) => group.isDefault);
      // in case there is no default, then just choose the first one
      if (!currentGroup && this.securityGroups) {
        this.currentSecurityGroup = this.securityGroups[0].id;
      } else if (currentGroup) {
        this.currentSecurityGroup = currentGroup.id;
      }

      this.users = userData.users;

      this.user = userData.user;

      this.user.userName = userData.userName;
      this.user.userPassword = userData.userPassword;
      // & NEW 03/29/2024
      this.user.selectedPatients = userData.selectedPatients;

      this.membership = userData.membership;
      this.businesses = userData.businesses;
      this.userLists = userData.userLists;
      // this.clinicians = userData.clinicians
      // this.locations = userData.locations
    },

    async fetchSchedule() {
      console.clear();
      console.log(" USER STORE  >  fetchSchedule");
      const result = await fetchSchedule();
      console.log("Result from fetchSchedule: ", result);

      if (result.ok) {
        console.log("Result from fetchSchedule: ", result.payload);
      }
    },
    async fetchAppointments() {
      // console.clear();
      // console.log(" USER STORE  >  fetchAppointments");
      const result = await fetchAppointments();
      // console.log("Result from fetchAppointments: ", result);

      if (result.ok) {
        console.log("Result from fetchAppointments: ", result.payload);
      }
    },

    async changeSecurityGroupToStore(groupId) {
      // console.log('                           changeSecurityGroupToStore   ')
      // console.log('groupId)')
      // console.log(groupId)

      const result = await changeSecurityGroup(groupId);
      if (result.ok) {
        await this.fetchUserData();

        // await this.fetchDashboards()

        // console.log('  USER STORE  HOOK  to dashboardsStore ')
        const dashboardsStore = useDashboardsStore();
        await dashboardsStore.fetchDashboards();

        this.commitCurrentSecurityGroup(groupId);

        // this.removeCurrentPatient()
        // console.log(' HOOK  to patientStore   removeCurrentPatient')
        const patientStore = usePatientStore();
        // console.log(" RUN  PATIENT CHECK CLEAR");

        if (patientStore.currentPatientId !== null) {
          // console.log(" HOOK  to patientStore   removeCurrentPatient");
          await patientStore.removeCurrentPatient();
        }
        this.setPatientChartBool();
      }
      return result;
    },

    commitCurrentSecurityGroup(securityGroup) {
      this.currentSecurityGroup = securityGroup;
    },

    async setUserCredentials({ commit }, { userName, userPassword }) {
      // console.log(' USER STORE :  setUserCredentials  payload' )
      // console.log(userName)
      // console.log(userPassword)
      const result = await setUserCredentials(userName, userPassword);
      // console.dir('   result: ', result)
      if (result.ok) {
        // console.dir('result ', result.payload)
        //commit('storeUserData', result.payload)
      }
      return result;
    },
    async setUserCredentialsWithPayload({ commit }, payload) {
      // console.log(' USER STORE :  setUserCredentials  payload' )
      // console.log(payload)
      const result = await setUserCredentials(payload);
      // console.dir('   result: ', result)
      if (result.ok) {
        // console.dir('result ', result.payload)
        //commit('storeUserData', result.payload)
      }
      return result;
    },
    async fetchPatientPanels({ commit }) {
      const result = await fetchPatientPanel();
      if (result.ok) {
        commit("storeUserData", result.payload);
      }
      return result;
    },

    setPatientChartBool() {
      if (this.currentSecurityGroup === this.ihaSecurityMaster) {
        this.hasFullPatientChart = true;
      } else {
        this.hasFullPatientChart = false;
      }
    },
    setUserCanEditAlertMessage(incBoolean) {
      // console.log('   USER STORE    setUserCanEditAlertMessage >> ')
      // console.log(incBoolean)
      this.userCanEditAlertMessage = incBoolean;
    },

    setReloadDash(state) {
      // console.log('setReloadDash')
      // console.log('reloadDashboard =  3')
      this.reloadDashboard = 3;
      // console.log(reloadDashboard)
    },

    // TODO  get MUTATIONs from ORIGINAL vueX store
    async setDashPageBooleam(incBool) {
      if (incBool) {
        this.reloadDashboard += 1;
      } else if (!incBool) {
        this.reloadDashboard += 2;

        const response = await fetchMyMeasures();
        // const response = await this.getAllMyMeasuresStoreToAPI()
        // console.log(' ............       await worklistApi.fetchMyMeasure       ............. 	response  ')
        // console.log(response)
        // console.log(' ......................... 	response  ')

        if (response.ok) {
          // console.log('			.......commit(setAllMyMeasures,....setAllMyMeasuresUSERS.........OK')
          //  this.commit('setAllMyMeasures', response.payload,{ root: true })
          const workListStore = useStoreWorkList();
          await workListStore.setAllMyMeasures(response.payload);
        }
      }
      // else {
      //   state.reloadDashboard = 0
      // }
      // // console.log(' USER STOre            RUN COMMIT setReloadDash')
      // this.commit('setReloadDash')
    },

    setUserIsAuthenticated(incBool) {
      this.isAuthenticated = incBool;
    },
  },
  getters: {
    // * ?  GETTER not need  if STATE IS NOT MODIFIED ???
    user: (state) => state._user,
    canUseTasks: (state) => state.currentSecurityGroup == state.ruralFamilyMedicineGroup,
    patientPanels: (state) => state.patientPanels,
    userRole: (state) => state.role,
    borderClass: (state) => {
      switch (state.bModalTheme) {
        case "generic-light-modal":
          return "generic-light-border";
        case "generic-dark-modal":
          return "generic-dark-border";
        case "generic-light-blue-modal":
          return "generic-light-blue-border";
        case "generic-dark-blue-modal":
          return "generic-dark-blue-border";
        case "generic-light-green-modal":
          return "generic-light-green-border";
        case "generic-dark-green-modal":
          return "generic-dark-green-border";
        case "generic-light-yellow-modal":
          return "generic-light-yellow-border";
        case "generic-dark-yellow-modal":
          return "generic-dark-yellow-border";
        case "generic-light-orange-modal":
          return "generic-light-orange-border";
        case "generic-dark-orange-modal":
          return "generic-dark-orange-border";
        case "generic-light-red-modal":
          return "generic-light-red-border";
        case "generic-dark-red-modal":
          return "generic-dark-red-border";
        case "generic-light-white-modal":
          return "generic-light-white-border";
        default:
          return "";
      }
    },
    filterClass: (state) => {
      switch (state.bModalTheme) {
        case "generic-light-modal":
          return "generic-light-filters";
        case "generic-dark-modal":
          return "generic-dark-filters";
        case "generic-light-blue-modal":
          return "generic-light-blue-filters";
        case "generic-dark-blue-modal":
          return "generic-dark-blue-filters";
        case "generic-light-green-modal":
          return "generic-light-green-filters";
        case "generic-dark-green-modal":
          return "generic-dark-green-filters";
        case "generic-light-yellow-modal":
          return "generic-light-yellow-filters";
        case "generic-dark-yellow-modal":
          return "generic-dark-yellow-filters";
        case "generic-light-orange-modal":
          return "generic-light-orange-filters";
        case "generic-dark-orange-modal":
          return "generic-dark-orange-filters";
        case "generic-light-red-modal":
          return "generic-light-red-filters";
        case "generic-dark-red-modal":
          return "generic-dark-red-filters";
        case "generic-light-white-modal":
          return "generic-light-white-filters";
        default:
          return "";
      }
    },
  },
});
